
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 18 17","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M17.04 2.228h-6.968v-1.6c0-.16-.07-.31-.194-.41a.529.529 0 00-.44-.114l-8.576 1.6a.533.533 0 00-.437.524V13.96c0 .256.183.477.437.524l8.575 1.6a.535.535 0 00.635-.524v-1.6h6.967a.535.535 0 00.536-.533V2.761a.535.535 0 00-.536-.533zM7.794 9.876a.53.53 0 01-.05.752.536.536 0 01-.756-.05L5.431 8.807l-1.367 1.749a.54.54 0 01-.753.093.533.533 0 01-.094-.75l1.494-1.91-1.474-1.677a.53.53 0 01.05-.752.537.537 0 01.758.05l1.337 1.521 1.588-2.03a.539.539 0 01.752-.094c.234.18.276.515.094.75L6.1 7.948l1.694 1.927zm8.708 3.018h-6.431v-1.067h1.608a.535.535 0 00.536-.533.535.535 0 00-.536-.533h-1.608V9.694h1.608a.535.535 0 00.536-.533.535.535 0 00-.536-.534h-1.608V7.561h1.608a.535.535 0 00.536-.534.535.535 0 00-.536-.533h-1.608V5.428h1.608a.535.535 0 00.536-.534.535.535 0 00-.536-.533h-1.608V3.294h6.431v9.6z","fill":"#748190"}})])
          )
        }
      }
    